import { useEffect, useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Zap, Radar, Bot, Wallet, History, ShieldAlert } from "lucide-react";
import { useTerminal } from "@/lib/terminal";
import { short } from "@/lib/format";
import { QuickAmount } from "@/components/QuickAmount";

const NAV = [
  { to: "/", label: "Pulse", icon: Radar, id: "nav-link-pulse" },
  { to: "/bot", label: "Sniper Bot", icon: Bot, id: "nav-link-bot" },
  { to: "/wallet", label: "Cüzdanlar", icon: Wallet, id: "nav-link-wallet" },
  { to: "/history", label: "Geçmiş", icon: History, id: "nav-link-history" },
];

function BotIndicator() {
  const { api } = useTerminal();
  const [alive, setAlive] = useState(false);
  useEffect(() => {
    const load = () => api("get", "/bot").then((d) => setAlive(d.alive)).catch(() => {});
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [api]);
  return (
    <Link to="/bot" data-testid="header-bot-indicator" className={`flex items-center gap-1.5 px-2.5 py-1 rounded border text-xs font-mono transition-colors ${alive ? "border-[#00E676]/40 text-[#00E676] bg-[#00E676]/10" : "border-[#222634] text-slate-500"}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${alive ? "bg-[#00E676] live-dot" : "bg-slate-600"}`} />
      BOT {alive ? "AKTİF" : "KAPALI"}
    </Link>
  );
}

export default function Layout() {
  const { wallet, forbidden } = useTerminal();
  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <header className="sticky top-0 z-30 bg-[#0A0C10]/90 backdrop-blur-md border-b border-[#222634]">
        <div className="flex items-center gap-4 px-3 sm:px-5 h-14">
          <Link to="/" className="flex items-center gap-1.5 font-bold text-[#00E676] tracking-tight" data-testid="logo-link">
            <Zap className="w-5 h-5" /> <span className="hidden sm:inline">FullSniper</span>
          </Link>
          <nav className="flex items-center gap-0.5 overflow-x-auto">
            {NAV.map(({ to, label, icon: Icon, id }) => (
              <NavLink key={to} to={to} end={to === "/"} data-testid={id}
                className={({ isActive }) => `flex items-center gap-1.5 px-3 py-1.5 rounded text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[#161920] text-slate-100" : "text-slate-400 hover:text-slate-200 hover:bg-[#101216]"}`}>
                <Icon className="w-4 h-4" /> <span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <QuickAmount />
            <span className="hidden lg:flex items-center gap-1.5 text-xs font-mono text-slate-500"><span className="w-1.5 h-1.5 rounded-full bg-[#00F0FF]" />Robinhood</span>
            <BotIndicator />
            <Link to="/wallet" data-testid="header-wallet-balance" className="hidden sm:flex items-center gap-2 px-2.5 py-1 rounded border border-[#222634] bg-[#101216] text-xs font-mono hover:border-[#333A4E] transition-colors">
              {wallet?.address ? (<><span className="text-slate-400">{wallet.count > 1 ? `${wallet.trade_count}/${wallet.count} cüzdan` : short(wallet.address)}</span><span className="text-slate-100">{Number(wallet.eth_balance).toFixed(4)} Ξ</span></>) : <span className="text-[#FFD700]">Cüzdan ekle</span>}
            </Link>
            <UserButton />
          </div>
        </div>
      </header>
      {forbidden ? (
        <div className="m-6 p-6 border border-[#FF5252]/40 bg-[#FF5252]/10 rounded flex items-center gap-3" data-testid="forbidden-banner">
          <ShieldAlert className="text-[#FF5252]" /> Bu panel sadece sahibine açık. Farklı bir hesapla giriş yaptınız.
        </div>
      ) : (
        <main className="flex-1 p-2 sm:p-4"><Outlet /></main>
      )}
    </div>
  );
}
